import axios from 'axios';

// Resolve backend base URL dynamically:
// - In production deployment, frontend and backend share the same domain (routing /api/* to backend via ingress).
//   Using same-origin avoids CORS issues when the deployed REACT_APP_BACKEND_URL points to a different subdomain.
// - In preview/dev, REACT_APP_BACKEND_URL is used.
const CONFIGURED_BASE = process.env.REACT_APP_BACKEND_URL || '';

function resolveBaseUrl() {
  if (typeof window === 'undefined') return CONFIGURED_BASE;
  const currentOrigin = window.location.origin;
  // If configured base is a different origin than the current page, prefer same-origin
  // (deployment scenario: page on www.viralsynth.com, but build has video-forge-417.emergent.host).
  // The ingress on the current origin will route /api/* to the backend anyway.
  if (CONFIGURED_BASE && !CONFIGURED_BASE.startsWith(currentOrigin)) {
    return currentOrigin;
  }
  return CONFIGURED_BASE || currentOrigin;
}

const API_BASE = resolveBaseUrl();

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
